import { useCallback } from 'react';
import FormattedJSXMessage from 'I18n/components/FormattedJSXMessage';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { Link } from 'foundations-components/transitional/components/Link';
import { LoadingButton } from 'foundations-components/transitional/components/LoadingButton';
import { Tooltip } from 'foundations-components/transitional/components/Tooltip';
import Log from 'forms-utils-lib/logger/Logger';
import { useFormAIWizard } from 'forms-ai-lib/hooks/useFormAIWizard';
import redirectToNewEditor from 'FormsUI/actions/formCreation/newEditor/redirectToNewEditor';
import { trackDashboardInteraction } from 'FormsUI/utils/TrackingUtils';
import { useGetAccessControlsQuery } from '../../../../__generated__/chirp/com/hubspot/ai/access/controls/rpc/AiAccessControlsChirpService.hooks';
import { getAISettingsUrl } from 'FormsUI/utils/UrlUtils';
import { jsx as _jsx } from "react/jsx-runtime";
const StartWithAIButton = ({
  isRequestStatePending = false,
  formsWriteAccess = false
}) => {
  const {
    data,
    loading
  } = useGetAccessControlsQuery();
  const {
    openFormAIWizard
  } = useFormAIWizard();
  const isLoading = isRequestStatePending || loading;
  const tooltipTitle = !(data !== null && data !== void 0 && data.generativeAiEnabled) ? /*#__PURE__*/_jsx(FormattedJSXMessage, {
    elements: {
      Link
    },
    options: {
      href: getAISettingsUrl(),
      external: true
    },
    message: "newCreateForm.disabledTooltip.generativeAi_jsx"
  }) : /*#__PURE__*/_jsx(FormattedMessage, {
    message: "newCreateForm.disabledTooltip.permissions"
  });
  const onClick = useCallback(() => {
    trackDashboardInteraction('start-with-ai-button-clicked');
    openFormAIWizard().then(result => {
      if (!result.cancelled) {
        redirectToNewEditor(result.formId, 'normal');
      }
    }).catch(error => {
      Log.error(`Unable to generate form`, error);
    });
  }, [openFormAIWizard]);
  return /*#__PURE__*/_jsx(Tooltip, {
    disabled: formsWriteAccess && (data === null || data === void 0 ? void 0 : data.generativeAiEnabled),
    placement: "bottom",
    title: tooltipTitle,
    children: /*#__PURE__*/_jsx(LoadingButton, {
      "data-test-id": "start-with-ai-button",
      disabled: !formsWriteAccess || !(data !== null && data !== void 0 && data.generativeAiEnabled),
      loading: isLoading,
      onClick: onClick
      // workaround: set this to true to prevent the checkmark from showing
      ,
      failed: true,
      size: "small",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "newCreateForm.buttons.startWithAIButton"
      })
    })
  });
};
export default StartWithAIButton;